import ApiGateway from '../aws/api-gateway/ApiGateway';
export const itemIsDeletable = async (params) => {
    const path = '/itemIsDeletable';
    const res = (await ApiGateway.post(path, params, 'ConsumerApi'));
    return res;
};
